import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Container from '@material-ui/core/Container';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import Layout from 'components/Layout';
import Background from 'components/Layout/Background';

import { HOME_PAGE } from 'routes';
import useStyles from './styles';

const Page404: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation().pathname;
  const classes = useStyles();

  return (
    <Layout title={t('pageTitle_404')}>
      <Background>
        <Container maxWidth="md">
          <Typography variant="h1" className={classes.error}>
            404
          </Typography>
          <Typography variant="h3">{t('error_404_title')}</Typography>
          <Typography className={classes.info}>
            <span
              dangerouslySetInnerHTML={{
                __html: t('error_404_info', {
                  location,
                  interpolation: { escapeValue: true },
                }),
              }}
            />
          </Typography>
          <Button variant="contained" color="primary" onClick={() => history.push(HOME_PAGE)}>
            {t('error_homePage')}
          </Button>
        </Container>
      </Background>
    </Layout>
  );
};

export default Page404;
